import React, { createContext, useState, useEffect } from "react";

/**
 * Context that stores the External form data request
 */
export const DataRequestContext = createContext();

export const DataRequestProvider = ({ children }) => {
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    const storedData = localStorage.getItem("DataRequest");
    if (storedData) {
      setFormData(JSON.parse(storedData));
    }
  }, []);

  useEffect(() => {
    if (formData) {
      localStorage.setItem("DataRequest", JSON.stringify(formData));
    }
  }, [formData]);
  return (
    <DataRequestContext.Provider value={{ formData, setFormData }}>
      {children}
    </DataRequestContext.Provider>
  );
};
